import React from 'react';
import { Badge } from '@mui/material';
import { useCurrentShopOutOfStockItems } from '../../../../views/RestaurantsPage/hooks/useRestaurantData';

/** Owns its data, so the queries only run while the out-of-stock link is shown. */
const OutOfStockBadge: React.FC<{ shopId: string; children: React.ReactNode }> = ({ shopId, children }) => {
  // Refetch only when stale: the drawer remounts on every tab switch, and the out-of-stock page and the mutations
  // already keep this shared query fresh.
  const { items } = useCurrentShopOutOfStockItems(shopId, true);

  return (
    <Badge color="highlight" badgeContent={items.length}>
      {children}
    </Badge>
  );
};

export default OutOfStockBadge;
